import {DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES} from 'constants/app.constants';
import {useLocation} from 'react-router-dom';

export const useLocale = (): ToolboxObject.Locale => {
  const location = useLocation();

  const lang = location.pathname.slice(1, 3);
  return SUPPORTED_LANGUAGES.includes(lang) ? (lang as ToolboxObject.Locale) : DEFAULT_LANGUAGE;
};
